// extracted by mini-css-extract-plugin
module.exports = {"box":"box--9FYMc","news":"news--Yab5I","tab":"tab--ViauB","item":"item--W9IX0","active":"active--mhH+Q","more":"more--5T1wl","list":"list--j5wN4","first":"first--2A2Nb"};